import RestError from '../../modules/app/errors';

export const REASON_CARD_USED = 'CARD_IS_ALREADY_ASSIGNED';
export const REASON_CARD_IS_BLOCKED = 'CARD_IS_BLOCKED';
export const REASON_CARD_NOT_FOUND = 'CARD_NOT_FOUND';
export const REASON_PHONE_USED = 'PHONE_IS_ALREADY_USED';

export class RegisterBadRequestError extends RestError {
}

export class RegisterConflictError extends RestError {}
